import React from 'react'

const DeliveryCharts = ({ statsWidget }) => {
  const performanceData = statsWidget?.charts?.top_delivery_companies_by_performance || [];
  const revenueData = statsWidget?.charts?.top_delivery_companies_by_revenue || [];
console.log('performanceData', performanceData)
  const TopStoresCard = ({ data, title }) => (
    <div className="col-md-6">
      <div className="card rounded-4">
        <div className="card-body">  
          <h6 className="mb-3">{title}</h6>
          <div className="row g-3">
            {data.map((company, index) => (
              <div key={index} className="col-12">
                <div className="best-stores-card  d-flex align-items-center p-3 border rounded">
                  <img
                    src={company.logo }
                    alt={company.name}
                    className="me-3"
                    style={{ width: '40px', height: '40px', borderRadius: '50%' }}
                 
                  />
                  <div>
                    <h6 className="mb-1">{company.name}</h6>
                    {company.percentage && (
                      <small className="text-muted">{company.percentage}%</small>
                    )}
                    {company.revenue && (
                      <small className="text-muted">${company.revenue}</small>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="row">
      <TopStoresCard
        data={performanceData}
        title="أفضل المتاجر أداءً"
      />
      <TopStoresCard
        data={revenueData}
        title="أعلى 3 شركات في الإيرادات"
      />
    </div>
  )
}

export default DeliveryCharts
